import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router'

export default function RouterDebugger() {
  const location = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    console.log('Navigation type:', navigationType) // POP, PUSH, REPLACE
    console.log('Location:', location)
  }, [location, navigationType])

  return null
}